import {Component} from 'react';
import PropTypes from 'prop-types';
import OptionalTitle from './OptionalTitle';
import {Form, TextArea} from 'semantic-ui-react';
import TextMeasurer from './TextMeasurer';
import './SummaryNotes.scss';

const MAX_LINES = 16;

export default class SummaryNotes extends Component {
  static propTypes = {
    enabled: PropTypes.bool.isRequired,
    title: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    maxLines: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,

  };

  static defaultProps = {
    enabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      lines: 0,
      focused: false,
    };
  }

  componentDidUpdate(prevProps) {
    if ((!this.state.focused || this.props.value !== prevProps.value) && this.props.value !== this.state.value) {
      this.setState({value: this.props.value});
    }
  }

  onFocus = () => {
    this.setState({focused: true});
  };

  onBlur = () => {
    const {onChange} = this.props;
    const {value} = this.state;
    this.setState({focused: false});
    onChange('value', value);
  };

  onChange = (e, {value}) => {
    this.setState({value});
  };

  render() {
    const {enabled = true, title, onChange, label, maxLines, placeholder} = this.props;
    const {value, lines} = this.state;
    const linesCount = maxLines || MAX_LINES;
    return (
      <Form className="SummaryNotes">
        {label && <div className="notes-label">
          {label}
        </div>}
        {title && <div className="notes-title">
          <OptionalTitle
            title={title}
            isEnabled={enabled}
            onUpdateData={(data) => Object.keys(data).forEach(k => onChange(k, data[k]))}
            placeholder="Notes from your agent"
          />
        </div>}
        <div className={`notes-description ${lines > linesCount ? 'error' : ''}`}>
            <TextArea
              autoHeight
              disabled={!enabled}
              rows={4}
              placeholder={placeholder}
              value={value}
              onChange={this.onChange}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />
          <span>{lines} / {linesCount} lines</span>
        </div>
        <TextMeasurer text={value ? value : ''} width={502} onLinesChange={(newLines) => this.setState({lines: newLines})}/>
      </Form>
    );
  }
}
